const SR = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);

export const speechSupported = () => !!SR;

const normalize = (s) =>
  s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/^(le|la|les|un|une|des|du|l')\s*/, "").replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim();

function similarity(a, b) {
  if (!a || !b) return 0;
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j++) d[0][j] = j;
  for (let i = 1; i <= a.length; i++)
    for (let j = 1; j <= b.length; j++)
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
  return 1 - d[a.length][b.length] / Math.max(a.length, b.length);
}

export function scorePronunciation(target, heardList) {
  const t = normalize(target);
  let best = { heard: heardList[0] || "", score: 0 };
  for (const h of heardList) {
    const n = normalize(h);
    const s = n.includes(t) ? 1 : Math.max(similarity(t, n), ...n.split(" ").map((w) => similarity(t, w)));
    if (s > best.score) best = { heard: h, score: s };
  }
  return { ...best, ok: best.score >= 0.75 };
}

export function listenOnce() {
  return new Promise((resolve, reject) => {
    if (!SR) return reject(new Error("unsupported"));
    const rec = new SR();
    rec.lang = "fr-FR";
    rec.maxAlternatives = 5;
    rec.interimResults = false;
    let done = false;
    rec.onresult = (e) => {
      done = true;
      resolve(Array.from(e.results[0]).map((a) => a.transcript));
    };
    rec.onerror = (e) => { done = true; reject(new Error(e.error)); };
    rec.onend = () => { if (!done) resolve([]); };
    rec.start();
  });
}
